<div class="max-w-4xl mx-auto mt-10">
  <h3 class="text-2xl font-bold mb-4">My Products</h3>
  <!--<button (click)="editingProduct = {}"
          class="mb-4 bg-indigo-600 text-white px-4 py-2 rounded-xl hover:bg-indigo-700">
    Add Product
  </button>-->
  <button (click)="goToAddProduct()"
          class="mb-4 bg-indigo-600 text-white px-4 py-2 rounded-xl hover:bg-indigo-700">
    Add Product
  </button>

  <!--<div *ngIf="editingProduct" class="mb-6 bg-gray-50 p-4 rounded-xl space-y-2">
    <input placeholder="Name" [(ngModel)]="editingProduct.name"
           class="w-full border rounded-xl px-3 py-2" />
    <input placeholder="Price" [(ngModel)]="editingProduct.price"
           class="w-full border rounded-xl px-3 py-2" />
    <button (click)="editingProduct.id ? update(editingProduct.id, editingProduct) : add(editingProduct)"
            class="bg-green-600 text-white px-4 py-2 rounded-xl hover:bg-green-700">
      Save
    </button>
  </div>-->


  <!--<ul class="divide-y divide-gray-200">
    <li *ngFor="let p of products" class="py-3 flex justify-between items-center">
      <div>
        <p class="font-medium">{{ p.name }}</p>
        <p class="text-gray-500">{{ p.price | currency }}</p>
      </div>
      <div class="space-x-2">
        <button (click)="editingProduct = edit(p)"
                class="bg-yellow-500 text-white px-3 py-1 rounded-xl hover:bg-yellow-600">
          Edit
        </button>
        <button (click)="remove(p.id)"
                class="bg-red-600 text-white px-3 py-1 rounded-xl hover:bg-red-700">
          Delete
        </button>
      </div>
    </li>
  </ul>-->

  <table class="w-full border-collapse border border-gray-300">
    <thead class="bg-gray-200">
      <tr>
        <th class="border p-2">Image</th>
        <th class="border p-2">Name</th>
        <th class="border p-2">Price</th>
        <th class="border p-2">Actions</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let product of products" class="text-center">
        <td class="border p-2">
          <img [src]="environment.apiBaseUrl+product.imagePath" alt="{{ product.name }}" class="h-16 w-16 object-cover mx-auto" />
        </td>
        <td class="border p-2">{{ product.name }}</td>
        <td class="border p-2">৳{{ product.price }}</td>
        <td class="border p-2">
          <button class="bg-blue-500 text-white px-3 py-1 rounded mr-2 hover:bg-blue-600"
                  (click)="editingProduct = edit(product)">
            Edit
          </button>
          <button class="bg-red-500 text-white px-3 py-1 rounded hover:bg-red-600"
                  (click)="remove(product.id)">
            Delete
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</div>
